<template>
  <div>
    <el-carousel height="410px" class="swImg" arrow="never">
      <el-carousel-item v-for="(item, index) in imgList" :key="index" class="pointer">
        <img style="height: 100%" :src="item.img" @click="nav(item)" />
      </el-carousel-item>
    </el-carousel>

    <div class="sidebar">
      <div class="s_left">
        <div class="lz">{{ uName }}</div>
        <div class="tt_main">
          <div @click="cho(item)" v-for="(item, index) in dList" :key="index"
            :class="dname == item.zName ? 'ttl cho' : 'ttl'">
            <div class="ttl_l"></div>
            <div class="n">{{ item.zName }}</div>
            <img v-if="dname == item.zName" src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x34.png"
              alt="" />
          </div>
        </div>
      </div>

      <div class="s_r">
        <div class="z_l">
          <div></div>
          {{ dname }}
        </div>
        <div class="llll"></div>

        <div class="z">
          <div v-if="zyContent" v-html="zyContent"></div>
          <div v-else>
            <el-empty description="暂无数据" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Know } from "@/api/know";
const know = new Know();
import { queryAllArticle, getJgZyListList } from "@/api/home";
import { DataClient } from "@/api/dataClient";
const dataClient = new DataClient();
import { getSurfaceList } from "@/api/home";
import { getDomain } from "@/api/cookies";
import { queryAllArticleid } from "@/api/home";

export default {
  name: "NewsDynamic",
  data() {
    return {
      dindex: 1,
      dname: "学校介绍",
      newsList: {},
      uName: "专业设置",
      imgList: [],
      dList: [
        {
          zName: "工商管理",
          zyContent:
            ` <div class="rich-text" style="font-family: 'Microsoft Yahei', sans-serif; line-height: 1.8; max-width: 1000px; margin: 0 auto;  ">
        <h3 style="color: #ff7a00; margin-top: 30px; margin-bottom: 15px;">（一）基本信息</h3>
        <table style="width: 100%; border-collapse: collapse; margin: 20px 0; border: 1px solid #e0e0e0;">
            <tr>
                <th style="background-color: #f8f9fa; color: #34495e; font-weight: bold; padding: 12px 15px; text-align: left; border-bottom: 1px solid #e0e0e0;">专业</th>
                <th style="background-color: #f8f9fa; color: #34495e; font-weight: bold; padding: 12px 15px; text-align: left; border-bottom: 1px solid #e0e0e0;">可授予学位</th>
                <th style="background-color: #f8f9fa; color: #34495e; font-weight: bold; padding: 12px 15px; text-align: left; border-bottom: 1px solid #e0e0e0;">主考院校</th>
                <th style="background-color: #f8f9fa; color: #34495e; font-weight: bold; padding: 12px 15px; text-align: left; border-bottom: 1px solid #e0e0e0;">计划招生</th>
            </tr>
            <tr style="background-color: #f9f9f9;">
                <td style="padding: 12px 15px; text-align: left; border-bottom: 1px solid #e0e0e0;">工商管理</td>
                <td style="padding: 12px 15px; text-align: left; border-bottom: 1px solid #e0e0e0;">管理学</td>
                <td style="padding: 12px 15px; text-align: left; border-bottom: 1px solid #e0e0e0;">哈尔滨工程大学</td>
                <td style="padding: 12px 15px; text-align: left; border-bottom: 1px solid #e0e0e0;">100人</td>
            </tr>
        </table>
        
        <h3 style="color: #ff7a00; margin-top: 30px; margin-bottom: 15px;">（二）专业简介</h3>
        <p style="margin: 15px 0; color: #555555;">工商管理专业是研究工商企业经济管理基本理论和一般方法的学科，主要包括企业的经营战略制定和内部行为管理两个方面。该专业旨在培养具备管理、经济、法律及企业管理方面的知识和能力，能在企、事业单位及政府部门从事管理以及教学、科研方面工作的工商管理学科高级专门人才。</p>
        
        <h3 style="color: #ff7a00; margin-top: 30px; margin-bottom: 15px;">（三）就业方向</h3>
        <ul style="margin: 15px 0 15px 30px; color: #555555;">
            <li style="margin-bottom: 10px;"><strong style="color: #2c3e50;">企业管理岗位</strong>：可在各类工商企业中担任基层管理干部，如生产主管、销售主管、人力资源主管等，负责企业某一部门或环节的管理工作；也有机会晋升为企业的中高层管理人员，参与企业的战略规划和整体运营管理。</li>
            <li style="margin-bottom: 10px;"><strong style="color: #2c3e50;">职能部门工作</strong>：进入企业的各个职能部门，如市场营销部门从事市场调研、产品推广、品牌管理等工作；在财务管理部门负责财务核算、资金管理、财务分析等；在人力资源部门从事人员招聘、培训与开发等工作；在生产运营部门参与生产计划制定、生产流程优化等工作。</li>
            <li style="margin-bottom: 10px;"><strong style="color: #2c3e50;">其他领域</strong>：还可以在政府经济管理部门、事业单位、金融机构等从事相关的管理和服务工作，或选择自主创业，运用所学的管理知识和技能创办和经营自己的企业。</li>
        </ul>
    </div>`,
          zStage: "高起专",
          studyName: "全日制",
        },
        {
          zName: "计算机科学与技术",
          zyContent:
            `<div class="rich-text" style="font-family: 'Microsoft Yahei', sans-serif; line-height: 1.8; max-width: 1000px; margin: 0 auto; ">
        <h3 style="color: #ff7a00; margin-top: 30px; margin-bottom: 15px;">（一）基本信息</h3>
        <table style="width: 100%; border-collapse: collapse; margin: 20px 0; border: 1px solid #e0e0e0;">
            <tr>
                <th style="background-color: #f8f9fa; color: #34495e; font-weight: bold; padding: 12px 15px; text-align: left; border-bottom: 1px solid #e0e0e0;">专业</th>
                <th style="background-color: #f8f9fa; color: #34495e; font-weight: bold; padding: 12px 15px; text-align: left; border-bottom: 1px solid #e0e0e0;">可授予学位</th>
                <th style="background-color: #f8f9fa; color: #34495e; font-weight: bold; padding: 12px 15px; text-align: left; border-bottom: 1px solid #e0e0e0;">主考院校</th>
                <th style="background-color: #f8f9fa; color: #34495e; font-weight: bold; padding: 12px 15px; text-align: left; border-bottom: 1px solid #e0e0e0;">计划招生</th>
            </tr>
            <tr style="background-color: #f9f9f9;">
                <td style="padding: 12px 15px; text-align: left; border-bottom: 1px solid #e0e0e0;">计算机科学与技术</td>
                <td style="padding: 12px 15px; text-align: left; border-bottom: 1px solid #e0e0e0;">工学</td>
                <td style="padding: 12px 15px; text-align: left; border-bottom: 1px solid #e0e0e0;">哈尔滨工程大学</td>
                <td style="padding: 12px 15px; text-align: left; border-bottom: 1px solid #e0e0e0;">100人</td>
            </tr>
        </table>
        
        <h3 style="color: #ff7a00; margin-top: 30px; margin-bottom: 15px;">（二）专业简介</h3>
        <p style="margin: 15px 0; color: #555555;">计算机科学与技术是研究计算机的设计与制造，利用计算机进行信息获取、表示、存储、处理、控制等的理论、原则、方法和技术的学科。它涵盖了从计算机硬件到软件，从算法理论到实际应用的广泛领域，是一门综合性很强的学科。</p>
        
        <h3 style="color: #ff7a00; margin-top: 30px; margin-bottom: 15px;">（三）就业方向</h3>
        <ul style="margin: 15px 0 15px 30px; color: #555555;">
            <li style="margin-bottom: 10px;"><strong style="color: #2c3e50;">软件开发与设计</strong>：可在软件公司、互联网企业等从事软件工程师、开发工程师等工作，负责各类软件系统的设计、开发、测试和维护，如网站开发、移动应用开发、企业级软件研发等。</li>
            <li style="margin-bottom: 10px;"><strong style="color: #2c3e50;">硬件研发与维护</strong>：在计算机硬件制造企业、电子设备公司等从事硬件工程师、系统架构师等工作，参与计算机硬件的设计、研发、生产和调试，以及计算机系统的组装、维护和升级。</li>
            <li style="margin-bottom: 10px;"><strong style="color: #2c3e50;">数据分析与人工智能</strong>：随着大数据和人工智能技术的发展，毕业生可以在数据分析公司、人工智能研究机构等从事数据分析师、算法工程师等工作。</li>
            <li style="margin-bottom: 10px;"><strong style="color: #2c3e50;">网络工程与信息安全</strong>：在网络通信、互联网、金融机构等，担任网络工程师、安全工程师，负责网络系统设计、建设、维护、管理，构建信息安全体系，制定策略并研发安全技术。</li>
        </ul>
    </div>`,
          zStage: "专升本",
          studyName: "全日制",
        },
        {
          zName: "汉语言文学",
          zyContent:
            ` <div class="rich-text" style="font-family: 'Microsoft Yahei', sans-serif; line-height: 1.8; max-width: 1000px; margin: 0 auto; ">
        <h3 style="color: #ff7a00; margin-top: 30px; margin-bottom: 15px;">（一）基本信息</h3>
        <table style="width: 100%; border-collapse: collapse; margin: 20px 0; border: 1px solid #e0e0e0;">
            <tr>
                <th style="background-color: #f8f9fa; color: #34495e; font-weight: bold; padding: 12px 15px; text-align: left; border-bottom: 1px solid #e0e0e0;">专业</th>
                <th style="background-color: #f8f9fa; color: #34495e; font-weight: bold; padding: 12px 15px; text-align: left; border-bottom: 1px solid #e0e0e0;">可授予学位</th>
                <th style="background-color: #f8f9fa; color: #34495e; font-weight: bold; padding: 12px 15px; text-align: left; border-bottom: 1px solid #e0e0e0;">主考院校</th>
                <th style="background-color: #f8f9fa; color: #34495e; font-weight: bold; padding: 12px 15px; text-align: left; border-bottom: 1px solid #e0e0e0;">计划招生</th>
            </tr>
            <tr style="background-color: #f9f9f9;">
                <td style="padding: 12px 15px; text-align: left; border-bottom: 1px solid #e0e0e0;">汉语言文学</td>
                <td style="padding: 12px 15px; text-align: left; border-bottom: 1px solid #e0e0e0;">文学</td>
                <td style="padding: 12px 15px; text-align: left; border-bottom: 1px solid #e0e0e0;">哈尔滨工程大学</td>
                <td style="padding: 12px 15px; text-align: left; border-bottom: 1px solid #e0e0e0;">100人</td>
            </tr>
        </table>
        
        <h3 style="color: #ff7a00; margin-top: 30px; margin-bottom: 15px;">（二）专业简介</h3>
        <p style="margin: 15px 0; color: #555555;">汉语言文学专业隶属中国语言文学学科，专注于研究汉语和中国文学。通过对语言文字运用和文学文化内涵的探究，培养具备扎实语言文字功底、较强文学鉴赏能力与人文素养的专业人才，是传承和弘扬中华优秀传统文化的重要专业领域。</p>
        
        <h3 style="color: #ff7a00; margin-top: 30px; margin-bottom: 15px;">（三）就业方向</h3>
        <ul style="margin: 15px 0 15px 30px; color: #555555;">
            <li style="margin-bottom: 10px;"><strong style="color: #2c3e50;">教育领域</strong>：担任中小学语文教师，负责语文课程教学，培养学生语言文字运用和文学素养；或进入高校担任汉语言文学专业助教、讲师，从事专业课程教学与科研工作。</li>
            <li style="margin-bottom: 10px;"><strong style="color: #2c3e50;">传媒出版行业</strong>：在报社、杂志社、电视台、网站等媒体机构，担任记者、编辑，负责新闻采编、内容策划与稿件编辑；在出版社从事文字编辑、校对、选题策划等工作。</li>
            <li style="margin-bottom: 10px;"><strong style="color: #2c3e50;">文化宣传部门</strong>：在政府机关、企事业单位宣传部门，负责撰写宣传文案、策划文化活动、运营新媒体账号，提升单位文化形象与传播力。</li>
            <li style="margin-bottom: 10px;"><strong style="color: #2c3e50;">文案策划与创作</strong>：在广告公司、公关公司等，为客户撰写广告文案、策划营销活动方案；部分毕业生凭借文学创作能力，成为自由撰稿人、网络作家，创作小说、散文、剧本等文学作品。</li>
        </ul>
    </div>`,
          zStage: "高起专",
          studyName: "全日制",
        },
        {
          zName: "法学",
          zyContent: `<div class="rich-text" style="font-family: 'Microsoft Yahei', sans-serif; line-height: 1.8; max-width: 1000px; margin: 0 auto;  background-color: #ffffff; ">
        <h3 style="color: #ff7a00; margin-top: 30px; margin-bottom: 15px;">（一）基本信息</h3>
        <table style="width: 100%; border-collapse: collapse; margin: 20px 0; border: 1px solid #e0e0e0;">
            <tr>
                <th style="background-color: #f8f9fa; color: #34495e; font-weight: bold; padding: 12px 15px; text-align: left; border-bottom: 1px solid #e0e0e0;">专业</th>
                <th style="background-color: #f8f9fa; color: #34495e; font-weight: bold; padding: 12px 15px; text-align: left; border-bottom: 1px solid #e0e0e0;">可授予学位</th>
                <th style="background-color: #f8f9fa; color: #34495e; font-weight: bold; padding: 12px 15px; text-align: left; border-bottom: 1px solid #e0e0e0;">主考院校</th>
                <th style="background-color: #f8f9fa; color: #34495e; font-weight: bold; padding: 12px 15px; text-align: left; border-bottom: 1px solid #e0e0e0;">计划招生</th>
            </tr>
            <tr style="background-color: #f9f9f9;">
                <td style="padding: 12px 15px; text-align: left; border-bottom: 1px solid #e0e0e0;">法学</td>
                <td style="padding: 12px 15px; text-align: left; border-bottom: 1px solid #e0e0e0;">法学</td>
                <td style="padding: 12px 15px; text-align: left; border-bottom: 1px solid #e0e0e0;">哈尔滨工程大学</td>
                <td style="padding: 12px 15px; text-align: left; border-bottom: 1px solid #e0e0e0;">100人</td>
            </tr>
        </table>
        
        <h3 style="color: #ff7a00; margin-top: 30px; margin-bottom: 15px;">（二）专业简介</h3>
        <p style="margin: 15px 0; color: #555555;">法学是一门研究法律现象及其规律的学科，涉及法律的制定、解释、实施、遵守以及法律与社会、经济、政治等方面的关系。它旨在培养学生掌握扎实的法律知识，具备运用法律思维分析和解决问题的能力，以及良好的法律职业道德和素养。</p>
        
        <h3 style="color: #ff7a00; margin-top: 30px; margin-bottom: 15px;">（三）就业方向</h3>
        <ul style="margin: 15px 0 15px 30px; color: #555555;">
            <li style="margin-bottom: 10px;"><strong style="color: #2c3e50;">司法机关</strong>：可担任法官、检察官，承担案件审理、提起公诉等司法任务，维护法律公正权威。</li>
            <li style="margin-bottom: 10px;"><strong style="color: #2c3e50;">律师事务所</strong>：以律师身份，为当事人提供法律咨询、代理诉讼及参与商务谈判等服务，保障其合法权益。</li>
            <li style="margin-bottom: 10px;"><strong style="color: #2c3e50;">企业法务部门</strong>：进入企业担任法务专员或法律顾问，负责合同审查、知识产权保护、合规管理等日常法律事务，防范法律风险。</li>
            <li style="margin-bottom: 10px;"><strong style="color: #2c3e50;">行政机关</strong>：行政执法部门依法履职，处理复议诉讼案件。立法机关参与法律法规起草修订，完善法治体系。</li>
            <li style="margin-bottom: 10px;"><strong style="color: #2c3e50;">教育科研机构</strong>：在研究院所或高校做法学理论研究，为法治建设提供理论支撑。高校教师承担教学任务，培育人才，参与教材编写与教法研究。</li>
        </ul>
    </div>`,
          zStage: "专升本",
          studyName: "全日制",
        },
        {
          zName: "视觉传达设计",
          zyContent: `<div class="rich-text" style="font-family: 'Microsoft Yahei', sans-serif; line-height: 1.8; max-width: 1000px; margin: 0 auto;   ">
        <h3 style="color: #ff7a00; margin-top: 30px; margin-bottom: 15px;">（一）基本信息</h3>
        <table style="width: 100%; border-collapse: collapse; margin: 20px 0; border: 1px solid #e0e0e0;">
            <tr>
                <th style="background-color: #f8f9fa; color: #34495e; font-weight: bold; padding: 12px 15px; text-align: left; border-bottom: 1px solid #e0e0e0;">专业</th>
                <th style="background-color: #f8f9fa; color: #34495e; font-weight: bold; padding: 12px 15px; text-align: left; border-bottom: 1px solid #e0e0e0;">可授予学位</th>
                <th style="background-color: #f8f9fa; color: #34495e; font-weight: bold; padding: 12px 15px; text-align: left; border-bottom: 1px solid #e0e0e0;">主考院校</th>
                <th style="background-color: #f8f9fa; color: #34495e; font-weight: bold; padding: 12px 15px; text-align: left; border-bottom: 1px solid #e0e0e0;">计划招生</th>
            </tr>
            <tr style="background-color: #f9f9f9;">
                <td style="padding: 12px 15px; text-align: left; border-bottom: 1px solid #e0e0e0;">视觉传达设计</td>
                <td style="padding: 12px 15px; text-align: left; border-bottom: 1px solid #e0e0e0;">艺术学</td>
                <td style="padding: 12px 15px; text-align: left; border-bottom: 1px solid #e0e0e0;">齐鲁工业大学</td>
                <td style="padding: 12px 15px; text-align: left; border-bottom: 1px solid #e0e0e0;">100人</td>
            </tr>
        </table>
        
        <h3 style="color: #ff7a00; margin-top: 30px; margin-bottom: 15px;">（二）专业简介</h3>
        <p style="margin: 15px 0; color: #555555;">视觉传达设计是一门专注于通过视觉元素进行信息传递与沟通的艺术与设计学科。它综合运用文字、图形、色彩、图像、影像等多种视觉符号，借助印刷、电子屏幕、网络等多种媒介，将信息以直观、生动且富有吸引力的方式呈现给受众。</p>
        
        <h3 style="color: #ff7a00; margin-top: 30px; margin-bottom: 15px;">（三）就业方向</h3>
        <ul style="margin: 15px 0 15px 30px; color: #555555;">
            <li style="margin-bottom: 10px;"><strong style="color: #2c3e50;">广告营销</strong>：从事广告、品牌设计，以及结合营销策略进行视觉内容的策划与制作。</li>
            <li style="margin-bottom: 10px;"><strong style="color: #2c3e50;">平面出版</strong>：负责书籍装帧、出版物插画、产品包装等设计工作。</li>
            <li style="margin-bottom: 10px;"><strong style="color: #2c3e50;">UI/UX设计</strong>：进行软件、网站、应用的界面设计，优化用户体验，提高满意度。</li>
            <li style="margin-bottom: 10px;"><strong style="color: #2c3e50;">影视动画</strong>：担任影视后期合成、动画设计、动态图形设计等工作。</li>
            <li style="margin-bottom: 10px;"><strong style="color: #2c3e50;">互联网新媒体</strong>：创作社交媒体视觉内容、短视频、H5页面等，吸引用户关注。</li>
            <li style="margin-bottom: 10px;"><strong style="color: #2c3e50;">文化艺术领域</strong>：从事展览展示设计，或在院校、机构担任艺术教育工作。</li>
            <li style="margin-bottom: 10px;"><strong style="color: #2c3e50;">艺术教育</strong>：在院校、机构任教师，传授设计知识与技能。</li>
        </ul>
    </div>`,
          zStage: "专升本",
          studyName: "全日制",
        },
        {
          zName: "网络与新媒体",
          zyContent: `<div class="rich-text" style="font-family: 'Microsoft Yahei', sans-serif; line-height: 1.8; max-width: 1000px; margin: 0 auto; ">
        <h3 style="color: #ff7a00; margin-top: 30px; margin-bottom: 15px;">（一）基本信息</h3>
        <table style="width: 100%; border-collapse: collapse; margin: 20px 0; border: 1px solid #e0e0e0;">
            <tr>
                <th style="background-color: #f8f9fa; color: #34495e; font-weight: bold; padding: 12px 15px; text-align: left; border-bottom: 1px solid #e0e0e0;">专业</th>
                <th style="background-color: #f8f9fa; color: #34495e; font-weight: bold; padding: 12px 15px; text-align: left; border-bottom: 1px solid #e0e0e0;">可授予学位</th>
                <th style="background-color: #f8f9fa; color: #34495e; font-weight: bold; padding: 12px 15px; text-align: left; border-bottom: 1px solid #e0e0e0;">主考院校</th>
                <th style="background-color: #f8f9fa; color: #34495e; font-weight: bold; padding: 12px 15px; text-align: left; border-bottom: 1px solid #e0e0e0;">计划招生</th>
            </tr>
            <tr style="background-color: #f9f9f9;">
                <td style="padding: 12px 15px; text-align: left; border-bottom: 1px solid #e0e0e0;">网络与新媒体</td>
                <td style="padding: 12px 15px; text-align: left; border-bottom: 1px solid #e0e0e0;">文学</td>
                <td style="padding: 12px 15px; text-align: left; border-bottom: 1px solid #e0e0e0;">中国传媒大学</td>
                <td style="padding: 12px 15px; text-align: left; border-bottom: 1px solid #e0e0e0;">100人</td>
            </tr>
        </table>
        
        <h3 style="color: #ff7a00; margin-top: 30px; margin-bottom: 15px;">（二）专业简介</h3>
        <p style="margin: 15px 0; color: #555555;">网络与新媒体专业融合了新闻学、传播学、计算机科学等多学科知识，聚焦于数字时代网络与新媒体领域的理论和实践。通过理论与实践相结合，培养具备扎实的新媒体专业知识、熟练掌握新媒体技术和传播技能，能够适应数字化时代媒体行业发展需求的复合型人才。</p>
        
        <h3 style="color: #ff7a00; margin-top: 30px; margin-bottom: 15px;">（三）就业方向</h3>
        <ul style="margin: 15px 0 15px 30px; color: #555555;">
            <li style="margin-bottom: 10px;"><strong style="color: #2c3e50;">互联网与新媒体企业</strong>：可担任新媒体运营专员，负责公司新媒体平台日常运维，提升用户活跃度与品牌影响力；或任内容编辑策划师，创作优质新媒体内容；也可做产品经理助理，协助进行新媒体产品的设计、开发及推广。</li>
            <li style="margin-bottom: 10px;"><strong style="color: #2c3e50;">传统媒体转型部门</strong>：在报社、电视台等传统媒体向新媒体转型过程中，对传统媒体内容进行数字化加工与传播；新媒体营销专员，为传统媒体开拓新的盈利模式。</li>
            <li style="margin-bottom: 10px;"><strong style="color: #2c3e50;">政府与企事业单位宣传部门</strong>：负责单位官方网站、社交媒体账号的运营维护；策划组织线上宣传活动；利用新媒体进行舆情监测与危机公关处理。</li>
            <li style="margin-bottom: 10px;"><strong style="color: #2c3e50;">自主创业</strong>：创办新媒体工作室或自媒体账号，通过内容变现、广告合作等途径实现商业价值。</li>
        </ul>
    </div>`,
          zStage: "专升本",
          studyName: "全日制",
        },
        {
          zName: "小学教育",
          zyContent: ` <div class="rich-text" style="font-family: 'Microsoft Yahei', sans-serif; line-height: 1.8; max-width: 1000px; margin: 0 auto;">
        <h3 style="color: #ff7a00; margin-top: 30px; margin-bottom: 15px;">（一）基本信息</h3>
        <table style="width: 100%; border-collapse: collapse; margin: 20px 0; border: 1px solid #e0e0e0;">
            <tr>
                <th style="background-color: #f8f9fa; color: #34495e; font-weight: bold; padding: 12px 15px; text-align: left; border-bottom: 1px solid #e0e0e0;">专业</th>
                <th style="background-color: #f8f9fa; color: #34495e; font-weight: bold; padding: 12px 15px; text-align: left; border-bottom: 1px solid #e0e0e0;">可授予学位</th>
                <th style="background-color: #f8f9fa; color: #34495e; font-weight: bold; padding: 12px 15px; text-align: left; border-bottom: 1px solid #e0e0e0;">主考院校</th>
                <th style="background-color: #f8f9fa; color: #34495e; font-weight: bold; padding: 12px 15px; text-align: left; border-bottom: 1px solid #e0e0e0;">计划招生</th>
            </tr>
            <tr style="background-color: #f9f9f9;">
                <td style="padding: 12px 15px; text-align: left; border-bottom: 1px solid #e0e0e0;">小学教育</td>
                <td style="padding: 12px 15px; text-align: left; border-bottom: 1px solid #e0e0e0;">教育学</td>
                <td style="padding: 12px 15px; text-align: left; border-bottom: 1px solid #e0e0e0;">山东师范大学</td>
                <td style="padding: 12px 15px; text-align: left; border-bottom: 1px solid #e0e0e0;">100人</td>
            </tr>
        </table>
        
        <h3 style="color: #ff7a00; margin-top: 30px; margin-bottom: 15px;">（二）专业简介</h3>
        <p style="margin: 15px 0; color: #555555;">小学教育专业专注于培养具备扎实专业知识、教育教学技能与高尚师德的小学教师。此专业围绕儿童身心发展规律与小学教育教学特点，致力于为学生提供全面系统的小学教育理论与实践训练，使其能胜任小学多学科教学及班级管理工作，推动小学教育事业发展。</p>
        
        <h3 style="color: #ff7a00; margin-top: 30px; margin-bottom: 15px;">（三）就业方向</h3>
        <ul style="margin: 15px 0 15px 30px; color: #555555;">
            <li style="margin-bottom: 10px;"><strong style="color: #2c3e50;">小学教师</strong>：可在公立小学、私立小学及各类教育培训机构担任语文、数学、英语等学科教师，依据教学大纲开展教学活动，激发学生学习兴趣，培养学生学习能力与综合素质。</li>
            <li style="margin-bottom: 10px;"><strong style="color: #2c3e50;">教育管理岗位</strong>：部分毕业生凭借在学习期间积累的管理知识与实践经验，进入学校行政管理部门，从事教学管理、学生管理、教务管理等工作，保障学校教育教学工作有序开展。</li>
            <li style="margin-bottom: 10px;"><strong style="color: #2c3e50;">教育研究机构</strong>：少数对教育研究有兴趣且具备一定研究能力的学生，可进入教育研究机构，参与小学教育相关课题研究，为教育政策制定、教学方法改进等提供理论支持与实践依据。</li>
        </ul>
    </div>`,
          zStage: "专升本",
          studyName: "全日制",
        },
      ],
      zyContent: "",
    };
  },
  created() {
    this.infoDomain = getDomain();
    if (this.$route.query.dname) {
      this.dname = this.$route.query.dname;
       const matchedItem = this.dList.find(item => item.zName === this.dname);
      if (matchedItem) {
        this.zyContent = matchedItem.zyContent;
      } else {
        // 未找到匹配项，设置默认内容
        this.zyContent = this.dList[0].zyContent;
      }
    } else {
      this.dname = this.dList[0].zName;
      this.zyContent = this.dList[0].zyContent;
    }

    this.getList();
  },
  methods: {
    cho(i) {
      this.dname = i.zName;
      this.zyContent = i.zyContent;
    },

    async getList() {
      getSurfaceList(15, undefined, this.infoDomain.entrantsType).then(
        (ress) => {
          if (ress.code == 0) {
            this.imgList = JSON.parse(JSON.stringify(ress.msg));
          }
        }
      );
      // getJgZyListList({ pageSize: 9999, pageNum: 1, productLine: 3 }).then((res) => {
      //   this.dList = res.rows;
      //   if (this.$route.query.dname) {
      //     this.dname = this.$route.query.dname
      //   } else {
      //     this.dname = this.dList[0].zName
      //     this.zyContent = this.dList[0].zyContent

      //   }
      // });
    },
  },
};
</script>

<style lang="scss" scoped>
.sidebar {
  width: 1200px;
  min-height: 920px;

  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  margin-top: 24px;
  margin-bottom: 80px;

  .s_left {
    width: 300px;
    height: fit-content;
    background: #f5fcff;
    border-radius: 0px 0px 0px 0px;
    position: sticky;
    /* 距离顶部 0 像素时固定 */
    top: 140px;
    /* 确保元素显示在其他内容上方 */
    z-index: 9;

    .lz {
      width: 300px;
      height: 74px;
      background: linear-gradient(91deg, #0073ff 0%, #0057c9 100%);
      border-radius: 0px 0px 0px 0px;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 24px;
      color: #ffffff;
      line-height: 74px;
      padding-left: 31px;
    }

    .lll {
      width: 219px;
      height: 0px;
      border: 1px solid #64a4f3;
      margin-top: 24px;
    }

    .tt_main {
      /* height: 300px; */
      overflow-y: scroll;
      overflow-x: hidden;
      scrollbar-width: none;
      /* Firefox */
      -ms-overflow-style: none;

      /* IE/Edge */
      .ttl {
        width: 300px;
        height: 69px;
        background: #f5fcff;
        border-radius: 0px 0px 0px 0px;
        display: flex;
        align-items: center;
        padding-right: 28px;
        cursor: pointer;

        .ttl_l {
          width: 3px;
          height: 69px;
          background: #6ac5ff;
          border-radius: 0px 0px 0px 0px;
        }

        .n {
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: 400;
          font-size: 16px;
          color: #333333;
          margin-left: 28px;
          flex: 1;
        }

        img {
          width: 24px;
          flex-shrink: 0;
        }
      }
    }

    .tt_main::-webkit-scrollbar {
      display: none;
      width: 0;
      height: 0;
    }

    .cho {
      background: #ffffff !important;

      .ttl_l {
        background: #2080f7 !important;
      }

      .n {
        color: #0074ef !important;
      }
    }
  }

  .s_r {
    width: 852px;

    .z_l {
      display: flex;
      align-items: center;

      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 20px;
      color: #0074ef;

      div {
        width: 15px;
        height: 15px;
        background: linear-gradient(180deg, #0073ff 0%, #0057c9 100%);
        border-radius: 2px 2px 2px 2px;
        margin-right: 8px;
      }
    }

    .llll {
      width: 100%;
      height: 2px;
      background: #0074ef;
      border-radius: 0px 0px 0px 0px;
      margin-top: 12px;
      margin-bottom: 20px;
    }

    .z {
      padding: 24px;
      background: #ffffff;
      border-radius: 12px 12px 12px 12px;

      .z_til {
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: bold;
        font-size: 20px;
        color: #333333;
      }

      .z_tils {
        width: fit-content;
        height: 24px;
        background: #fff1e9;
        border-radius: 4px 4px 4px 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: MiSans, MiSans;
        font-weight: 500;
        font-size: 12px;
        color: #ff580d;
        margin-top: 16px;
        margin-bottom: 20px;
        padding: 0 8px;

        img {
          width: 12px;
          margin-right: 6px;
        }
      }
    }
  }
}

.swImg {
  img {
    width: 100%;
  }
}
</style>
